import unlockedFeaturesFullNames from "../datasets/unlocked_features_full_names";
import determineSavingsLevel from "../../moneyBuilder/savings/objects/determine_savings_level";

export const determineUnlockedFeatureLevels = (savingsInfo, summaryInvestment, funStuff, 
        creditCardInfo, timeWizardInfo) => {
    let levelArr = [];
    for (let i=0; i<unlockedFeaturesFullNames.length; i++){
        let level = 0;
        let levelObj = {};
        const featureName = unlockedFeaturesFullNames[i].featureName;
        switch (featureName){
            case "moneyBuilder":
                if (summaryInvestment.length > 0){
                    const allInvestments = summaryInvestment.find(elem => elem.investType === "all");
                    if (allInvestments && +allInvestments.currentValue > 0){  
                        level = 3;
                    }
                }
                if (level === 0){
                    if (savingsInfo.savingsArr){
                        level = determineSavingsLevel(savingsInfo);
                    }
                }
                break;
            case "funStuff":
                if (funStuff.itemArr){
                    for (let j=0; j<funStuff.itemArr.length; j++){
                        const funStuffLevel = funStuff.itemArr[j].levelNbr;
                        if (funStuffLevel > level){
                            level = funStuffLevel;
                        } 
                    }
                }
                break;
            case "creditCard":
                if (creditCardInfo.cardLevel){
                    level = creditCardInfo.cardLevel;
                }
                break;
            case "timeWizard":
                if (timeWizardInfo.level){
                    level = timeWizardInfo.level;
                }
                break;
            default:
                break;
        }
        levelObj = {featureName: featureName, level: level};
        levelArr.push(levelObj);
    }
    return levelArr;
}
export default determineUnlockedFeatureLevels;